import buy from "./img/buy.png";
import Service from "./img/Service.png";
import news from "./img/newspaper-folded.png";
//
import sell from "./img/sell.png";
import rental from "./img/Rental.png";
import parts from "./img/spare-parts.png";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const SellBuyMob = () => {
    var objdatasting = JSON.parse(localStorage.getItem("data"));

  return (
    <>
      <div className="my-6">
        <h4 className="text-center mb-1 font-medium font-roboto text-xs mt-3">
          Explore Showroom
        </h4>
        <div className="flex md:hidden container mt-2">
          <div className="flex The_main">
            <div className="flex flex-col one  rounded mx-1 cus_height">
              <Link to="/new-implements">
                <img src={buy} alt="" />
                <span className="text-center font_s">Buy</span>
              </Link>
            </div>
            <div className="flex flex-col one rounded mx-1 cus_height">
              <Link to="/">
                <img src={Service} alt="" />
                <span className="text-center font_s">Service</span>
              </Link>
            </div>
            <div className="flex flex-col one rounded mx-1 cus_height">
              <Link to="/">
                <img src={rental} alt="" />
                <span className="text-center font_s">Rental</span>
              </Link>
            </div>
          </div>
        </div>
        <div className="flex md:hidden container mt-3">
          <div class="flex The_main">
            <div className="flex flex-col one  rounded mx-1 cus_height">
              {objdatasting?.full_name ? (
                <div>
                  <small className="text-xs cursor-pointer hidden lg:block text-slate-500">
                    {" "}
                  </small>
                  <Link to="/profile">
                    <img src={sell} alt="sell machine icon" />
                    <span className="text-center font_s">Sell</span>
                  </Link>
                </div>
              ) : (
                <div>
                  <Link to="#">
                    <img src={sell} alt="sell machine icon" />
                    <span className="text-center font_s">Sell</span>
                  </Link>
                </div>
              )}
            </div>
            <div className="flex flex-col one  rounded mx-1 cus_height">
              <Link to="/">
                <img src={parts} alt="compare icon" />
                <span className="text-center font_s">Parts</span>
              </Link>
            </div>
            <div className="flex flex-col one rounded mx-1 cus_height">
              <a href="#agro_blog_sec">
                <img src={news} alt="news icon" />
                <span className="text-center font_s">News/Blog</span>
              </a>
            </div>
          </div>
        </div>

        <div className="container">
          <ButtonPrimary href="/new-implements" className="w-full mt-4" fontSize="text-xs">
            Expore More
          </ButtonPrimary>
        </div>
      </div>
    </>
  );
};

export default SellBuyMob;
